import { CC_TYPES } from "@stadium/checkout/src/constants/cards";

import MasterCardLogo from "@stadium/checkout/src/assets/images/cards/mastercard.svg";
import VisaCardLogo from "@stadium/checkout/src/assets/images/cards/visa.svg";
import AmexCardLogo from "@stadium/checkout/src/assets/images/cards/amex.svg";
import DiscoverCardLogo from "@stadium/checkout/src/assets/images/cards/discover.svg";
import DinersCardLogo from "@stadium/checkout/src/assets/images/cards/diners.svg";
import JcbCardLogo from "@stadium/checkout/src/assets/images/cards/jcb.svg";

export const getCcTypeImage = ({ ccType }) => {
  switch (ccType) {
    case CC_TYPES.visa:
      return VisaCardLogo;
    case CC_TYPES.amex:
      return AmexCardLogo;
    case CC_TYPES.jcb:
      return JcbCardLogo;
    case CC_TYPES.diners:
      return DinersCardLogo;
    case CC_TYPES.discover:
      return DiscoverCardLogo;
    case CC_TYPES.mastercard:
      return MasterCardLogo;
    default:
      return null;
  }
};
